/* import __COLOCATED_TEMPLATE__ from './phone-number-form.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { Button } from '@repo/design-system-kit';
import { dropTask } from 'ember-concurrency';

import { AVAILABLE_COUNTRY_CODES } from 'register-partners-js/constants/countries';

import styles from './phone-number-form.module.css';

const COUNTRIES_CODES = ['FR', ...AVAILABLE_COUNTRY_CODES];

export default class PhoneNumberForm extends Component {
  styles = styles;

  button = Button;
  @service intl;
  @service segment;

  @tracked isNumberValid;
  @tracked wasNumberValid;
  @tracked hasSubmitted = false;
  @tracked agreedToConditions = false;

  @tracked currentPhoneNumber = this.args.phoneNumber;

  _isFirstKeyboardType(e) {
    let inputHasOneChar = e.target.value && e.target.value.length === 1;
    let isBackspaceOrDelete = e.keyCode === 8 || e.keyCode === 46;
    return inputHasOneChar && !isBackspaceOrDelete;
  }

  get initialCountry() {
    return COUNTRIES_CODES.includes(this.args.organization.get('legalCountry'))
      ? this.args.organization.get('legalCountry')
      : 'FR';
  }

  get phoneNumberErrors() {
    if (this.args.error) {
      return this.args.error;
    }

    if (!this.hasSubmitted || this.isNumberValid) {
      return null;
    }

    if (this.currentPhoneNumber && !this.isNumberValid) {
      return this.intl.t('validations.errors.phone-number-invalid');
    }
    return this.intl.t('validations.errors.phone-number-empty');
  }

  submitFormTask = dropTask(async () => {
    this.hasSubmitted = true;

    if (this.isNumberValid) {
      await this.args.submitTask.linked().perform(this.currentPhoneNumber, this.agreedToConditions);
    }
  });

  handleGobackTask = dropTask(async () => {
    await this.args.goBack();
  });

  @action
  sendAnalyticsForPhone(e) {
    if (this._isFirstKeyboardType(e)) {
      this.segment.track('onboarding_partner_phone_typing_started');
    }

    if (this.isNumberValid && !this.wasNumberValid) {
      this.segment.track('onboarding_partner_phone_validated', {
        command: 'onboarding_step',
        step_name: 'onboarding_partner_phone_validated',
      });
      this.wasNumberValid = true;
    }

    if (!this.isNumberValid) {
      this.wasNumberValid = false;
    }
  }

  @action
  handleUpdatePhoneNumber(value, { isValidNumber }) {
    // add workaround fix while we wait for https://github.com/qonto/ember-phone-input/pull/354 to be released
    if (this.currentPhoneNumber !== value) {
      this.currentPhoneNumber = value;
    }
    this.isNumberValid = isValidNumber;
    this.hasSubmitted = false;
  }

  @action
  toggleConditionsCheckbox() {
    this.agreedToConditions = !this.agreedToConditions;
  }
}
